import paramsToString, { BaseCamelCasedResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";

export interface ConnectedLoanAccountViewModel {
	backofficeLoanId: string;
	customerName: string;
	guarantorName: string;
	amount: number;
}

export interface ConnectedLienViewModel {
	propertyIdentifier: string;
	eAppraisalValue: number;
	maxLoanAmount: number;
	eAppraisalDate: Date;
	priority: number;
	utilizedSecurityValue: number;
	registeredDate: Date;
	documentId: string;
	connectedLoans: ConnectedLoanAccountViewModel[];
}

export interface ConnectedLienEngagementViewModel {
	connectedLiens: ConnectedLienViewModel[];
}

export class ConnectedLiensOverviewResource
	extends BaseCamelCasedResource
	implements ConnectedLienEngagementViewModel
{
	connectedLiens: ConnectedLienViewModel[] = [];

	pk() {
		return "ConnectedLienEngagement";
	}

	static url<T extends typeof BaseCamelCasedResource>(
		this: T,
		urlParams: Readonly<Record<string, any>>
	) {
		return `${this.urlRoot}${paramsToString(urlParams)}`;
	}

	static urlRoot = legacyApiResourceUrl(
		"CustomerEngagement/ConnectedLienEngagement"
	);
}
